import {otsBaseApi} from "../../ots-api";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ["InvoiceGroupBy", "InvoiceGroupByType"]});

const invoiceGroupByApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllInvoiceGroupBys: builder.query<string[], void>({
      query: () => ({
        url: `/invoice/grouping/group-bys`,
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }),
      providesTags: (result) => {
        if (result) {
          return [
            ...result.map((val) => ({type: 'InvoiceGroupBy', val} as const)),
            {type: 'InvoiceGroupBy', id: 'LIST'},
          ];
        } else {
          return [{type: 'InvoiceGroupBy', id: 'LIST'}];
        }
      },
    }),
    getAllInvoiceGroupByTypes: builder.query<string[], void>({
      query: () => ({
        url: `/invoice/grouping/group-by-types`,
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }),
      providesTags: (result) => {
        if (result) {
          return [
            ...result.map((val) => ({type: 'InvoiceGroupByType', val} as const)),
            {type: 'InvoiceGroupByType', id: 'LIST'},
          ];
        } else {
          return [{type: 'InvoiceGroupByType', id: 'LIST'}];
        }
      },
    }),
  }),
})

export const {
  useGetAllInvoiceGroupBysQuery,
  useGetAllInvoiceGroupByTypesQuery,
} = invoiceGroupByApi;
